import script from "./Tag.vue?vue&type=script&setup=true&lang=js"
export * from "./Tag.vue?vue&type=script&setup=true&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=5d0d7072&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d0d7072"]])

export default __exports__